import React from "react";
import { Field } from "formik";
import IField from "../../../../interfaces/field";
import TplGroup from "../tpl-group";
import { Container, Wrapper, ListElement, ListItem } from "./styles";

type IProps = any & IField;

const ActivitiesList = ({
  name,
  title,
  prefixName = "",
  required = false,
  ...el
}: IProps): JSX.Element => (
  <Field {...el} name={`${prefixName}${name}`}>
    {({ field }: any) => {
      const activities = field.value || [];

      if (!activities || activities.length === 0) {
        return <></>;
      }

      return (
        <Container>
          <TplGroup
            name={`${prefixName}${name}`}
            prefixName={prefixName}
            title={title}
            required={required}
            {...el}
          >
            <Wrapper>
              <ListElement>
                {activities.map((act: any, idx: number) => (
                  <ListItem
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "4px",
                    }}
                  >
                    <strong style={{ whiteSpace: "nowrap", flexShrink: 0 }}>
                      {act.codigo}
                    </strong>
                    <span>
                      {" - "} {act.descricao} (
                      {act.tipo === "principal" ? "Principal" : "Secundária"})
                    </span>
                  </ListItem>
                ))}
              </ListElement>
            </Wrapper>
          </TplGroup>
        </Container>
      );
    }}
  </Field>
);

export default ActivitiesList;
